import { render, staticRenderFns } from "./edit-booking.vue?vue&type=template&id=58386a18"
import script from "./edit-booking.vue?vue&type=script&lang=js"
export * from "./edit-booking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports